import { FinishedActionTypes, SET_FINISHED } from './actionTypes';

export const setFinished = (loading: boolean): FinishedActionTypes => ({
    type: SET_FINISHED,
    payload: loading
});